namespace $.$$ {
		export class $shm_hitalama_benchmarks_page extends $.$shm_hitalama_benchmarks_page {
		private preview?: $shm_hitalama_benchmarks_client_frame
		@ $mol_mem override Live(){ $mol_wire_solid();return this.preview??=super.Live() }
		@ $mol_mem client() { return new this.$.$shm_hitalama_benchmarks_client }
		connection_auto() { this.client().listen(); return null }
		archive_auto() {
			this.client().state()
			const catalog = this.client().archive().catalog()
			catalog?.units()
			catalog?.can_change()
			this.archive_status()
			return null
		}
		indexes_auto() {
			this.client().archive().row_index()
			this.client().archive().index_counts_ensure()
			return null
		}
		@ $mol_mem archive_status() {
			this.client().state()
			const catalog = this.client().archive().catalog()
			catalog?.units()
			catalog?.can_change()
			return this.$.$mol_error_fence(
				()=> this.client().archive_flush() ? '' : 'Результаты ожидают записи в гипербазу. Каталог домена пока недоступен. Не закрывайте страницу до завершения записи.',
				error=> `Не удалось записать результаты в гипербазу: ${error.message}. Не закрывайте страницу до завершения записи.`,
				()=> 'Отправка результатов в каталог домена…',
			)
		}
		@ $mol_mem override computer(next?: string) {
			return this.$.$mol_state_local.value<string>('hitalama.benchmark.computer', next) ?? ''
		}
		connected() { return this.client().connected() }
		busy() { return [ 'running', 'stopping' ].includes( this.client().state().active?.status ?? '' ) }
		start_enabled() { return this.connected() && !this.busy() }
		stop_enabled() { return this.connected() && this.client().state().active?.status === 'running' }
		error_text() { return this.client().error() || this.client().state().active?.report.rows.find((row:any)=>row.error)?.error || this.archive_status() }
		@ $mol_action start( event?: Event ) {
			if( !event ) return null
			if( !this.start_enabled() ) return null
			this.page_number(0)
			const profile = this.$.$shm_hitalama_profile.current()
			this.client().send({ command: 'start', meta: {
				user: profile?.Login()?.val() || 'Без имени',
				userId: this.$.$giper_baza_auth.current().pass().lord().str,
				computer: this.computer(),
				browser: this.$.$shm_hitalama_benchmarks_archive.browser(navigator),
				version: this.version(),
			}, config: {
				counts: this.count() === 'all' ? [1,100,500,1000,2000,4000,8000] : [Number(this.count())],
				properties: this.fields() === 'all' ? [4,10] : [Number(this.fields())],
				modes: ['shard256'],
				packings: this.packing() === 'all' ? ['granular','packed'] : [this.packing()],
			} })
			return event
		}
		@ $mol_action stop( event?: Event ) {
			if( event ) this.client().send({ command: 'stop' })
			return event ?? null
		}
		status_text() {
			const active = this.client().state().active
			if( !active ) return 'Готов к запуску'
			const labels: Record<string,string> = {running:'Выполняется',stopping:'Останавливается',stopped:'Остановлен',complete:'Завершён',failed:'Ошибка'}
			const row = active.report?.rows?.at(-1)
			const phases: Record<string,string> = {
				schema:'Подготовка таблицы',create:'Создание записей',f5:'Перезагрузка',cold:'Первый поиск',warm:'Повторный поиск',
				'status-reload':'Перезагрузка перед фильтром',status:'Фильтр Status','add-reload':'Перезагрузка перед добавлением',add:'Добавление записи',
				'verify-reload':'Перезагрузка для проверки','verify-values':'Проверка сохранённых значений',complete:'Готово',
			}
			return `${labels[active.status] ?? active.status}${row ? ` · ${row.count} записей · ${row.properties} свойств · ${this.storage_title(row.storage)} · ${phases[row.phase] ?? row.phase}` : ''}`
		}
		duration_text() {
			const milliseconds = this.client().state().active?.report.meta?.totalMs
			return typeof milliseconds === 'number' && Number.isFinite(milliseconds) && milliseconds >= 0
				? `Суммарное время прогона: ${(milliseconds / 1000).toFixed(2)} с`
				: ''
		}
		storage_title(storage:string) {
			return ({single:'Land',area:'Area',shard64:'Шарды 64',shard256:'Шарды 256'} as Record<string,string>)[storage] ?? storage
		}
		@ $mol_mem runs() {
			const locations = [...new Map(this.selected_rows().filter(row=>row.location).map(row=>[row.id,row.location!])).values()]
			const runs = new Map(this.client().archive().read_batch(locations).filter(run=>run!==null).map(run=> [run!.meta.id, run!]))
			const state = this.client().state()
			for (const pending of state.history) {
				if (this.selected_rows().some(row=>row.id===pending.report.meta.id && !row.location)) {
					runs.set(pending.report.meta.id,pending.report)
				}
			}
			if (state.active?.report.meta && this.selected_rows().some(row=> row.id===state.active!.report.meta.id && !row.location)) {
				runs.set(state.active.report.meta.id, {meta: state.active.report.meta, rows: state.active.report.rows})
			}
			return [...runs.values()].sort((a, b)=> b.meta.started.localeCompare(a.meta.started) || a.meta.id.localeCompare(b.meta.id))
		}
		@ $mol_mem row_index() {
			const entries = new Map<string,{id:string,started:string,location:readonly [string,string]|null,size:number,count:number,deleted:number[]}>(this.client().archive().row_index().map(entry=> [entry.id, entry]))
			const state = this.client().state(), active = state.active
			const pending = state.history.map(run=>run.report)
			if (active?.report.meta && ['running','stopping'].includes(active.status)) pending.push(active.report)
			for (const report of pending) {
				const meta = report.meta
				if (!entries.has(meta.id)) entries.set(meta.id, {id:meta.id,started:meta.started,location:null,size:report.rows.length,count:report.rows.length,deleted:[]})
			}
			return [...entries.values()].sort((a,b)=> b.started.localeCompare(a.started) || a.id.localeCompare(b.id))
		}
		total_rows() { return this.row_index().reduce((sum, entry)=>sum+entry.count,0) }
		override pagination_views() { return this.total_rows() > 50 ? [this.Pagination_top()] : [] }
		page_current() { return Math.max(0,Math.min(this.page_number(),Math.max(0,Math.ceil(this.total_rows()/50)-1))) }
		@ $mol_mem selected_rows() {
			const total = this.total_rows()
			const offset = this.page_current()*50
			const rows: {id:string,index:number,number:number,location:readonly [string,string]|null}[] = []
			let position = 0
			for (const entry of this.row_index()) {
				if (position+entry.count<=offset) { position+=entry.count;continue }
				const deleted = new Set(entry.deleted)
				for (let index=entry.size-1;index>=0;--index) {
					if (deleted.has(index)) continue
					if (position>=offset) rows.push({id:entry.id,index,number:total-position,location:entry.location})
					++position
					if (rows.length===50) return rows
				}
			}
			return rows
		}
		@ $mol_mem archive_page() { return {runs:this.runs(),more:this.next_enabled()} }
		previous_enabled() { return this.page_current() > 0 }
		next_enabled() { return (this.page_current()+1)*50<this.total_rows() }
		@ $mol_action previous(event?: Event) {
			if (event && this.previous_enabled()) this.page_number(this.page_current() - 1)
			return event ?? null
		}
		@ $mol_action next(event?: Event) {
			if (event && this.next_enabled()) this.page_number(this.page_current() + 1)
			return event ?? null
		}
		frame_uri() { return this.client().frame() || 'about:blank' }
		override live_views() {
			// Keep a running frame mounted even when inspecting an older report.
			// An idle blank frame has nothing to show and only hides the results.
			const uri=this.client().frame()
			return uri&&uri!=='about:blank'?[this.Live()]:[]
		}
		@ $mol_mem report_blob() {
			// Download reads the complete archive on demand, never during table rendering.
			const saved = this.client().archive().runs().map(run=> ({...run, rows: run.rows.filter((_, index)=> !this.client().archive().row_deleted(run.meta.id, index, run.meta.archiveShard))}))
			const runs = [...new Map([...saved, ...this.client().state().history.map(run=>run.report)].map(run=>[run.meta.id, run])).values()]
			return new $mol_blob([JSON.stringify(runs,null,2)],{type:'application/json'})
		}
		@ $mol_action row_delete(key: string, event?: Event | null) {
			if (!event) return null
			const split = key.lastIndexOf('/')
			const id = key.slice(0, split)
			const run = this.runs().find(run=> run.meta.id === id)
			this.client().archive().row_delete(id, Number(key.slice(split + 1)), run?.meta.archiveShard)
			return event
		}
		@ $mol_mem metrics() {
			const formatted = Object.assign({}, ...this.runs().map(run=> run.meta.archiveKey
				? this.run_metrics([run.meta.archiveShard ?? '', run.meta.archiveKey])
				: this.format_run(run)))
			return Object.fromEntries(this.selected_rows().flatMap(row=> {
				const key = `${row.id}/${row.index}`
				return formatted[key] ? [[key, {'№':row.number,...formatted[key]}]] : []
			}))
		}
		@ $mol_mem_key run_metrics(location: readonly [string, string]) {
			const run = this.client().archive().read_from(location)
			return run ? this.format_run(run) : {}
		}
		private readonly date_formatter = new Intl.DateTimeFormat('ru-RU', {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit',second:'2-digit'})
		format_run(run: {meta: $shm_hitalama_benchmarks_archive_meta, rows: readonly any[]}) {
			const date = new Date(run.meta.started)
			const stamp = Number.isFinite(date.getTime()) ? this.date_formatter.format(date) : 'Не сохранено'
			return Object.fromEntries(run.rows.map((row: any,index: number)=> {
				if (this.client().archive().row_deleted(run.meta.id, index, run.meta.archiveShard ?? '')) return null
				const time = (key: string)=> Number.isFinite(row.measurements[key]) ? (row.measurements[key]/1000).toFixed(2) : row.metricLimits?.[key] ? '>120' : '—'
				const status=({running:'Выполняется',passed:'Готово',failed:'Ошибка',stopped:'Остановлен','over-limit':'Лимит >120 с'} as Record<string,string>)[row.status] ?? row.status
				return [`${run.meta.id}/${index}`,{ 'Дата и время':stamp,'Версия Hitalama':run.meta.version ? `v${run.meta.version}` : 'Не сохранено','Записей':row.count,'Полей':row.properties,'Схема':this.storage_title(row.storage),'Атомы':row.packing==='packed'?'Initial':'Отдельные','Состояние':status,'Создание, с':time('create'),'F5, с':time('f5'),'Первый поиск, с':time('cold'),'Повторный поиск, с':time('warm'),'Первый поиск индексированного свойства, с':time('status'),'Добавить 1, с':time('add'),'Пользователь':run.meta.user,'Компьютер':run.meta,'Удалить':run.meta.archiveKey !== undefined }]
			}).filter((entry): entry is NonNullable<typeof entry>=> entry !== null))
		}
	}
}
